import axios, { AxiosResponse } from "axios";
import { SupplierInfo } from "../types/supplier";
import { API_URL, getBaseConfig, handleError } from "./apiConfig";

/**
 * Get active suppliers (ID & Display Name) for dropdowns
 */
export async function getSuppliersDropdown(): Promise<SupplierInfo[] | void> {
    const config = { ...getBaseConfig(), baseURL: API_URL };

    return axios
        .post("Supplier/GetAll", {}, config)
        .then((response: AxiosResponse<any[]>) => {
            if (response.status === 200 && Array.isArray(response.data)) {
                return response.data.map(s => ({
                    id: s.id,
                    businessDisplayName: s.businessDisplayName || s.businessName,
                    templateSelection: s.templateSelection || "Default"
                }));
            }
            return [];
        })
        .catch(handleError);
}
